// CodeMirror + Ohm Example with styling
// https://github.com/harc/ohm/blob/master/examples/incremental/index.html

import 'codemirror/addon/hint/show-hint'
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/addon/lint/lint.css'
import 'codemirror/addon/lint/lint.js'
import 'codemirror/addon/mode/simple'
import 'codemirror/keymap/sublime'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/monokai.css'
import CodeMirror from 'codemirror'

import { Preview } from './Preview'
import { TypedEvent } from '../typed-event'

import './codemirror.styles.css'

import { Formml } from 'formml'
const { Builder, Renderers } = Formml

import { codeMirrorConfig } from './codemirror-config'

CodeMirror.defineSimpleMode('formml', codeMirrorConfig)

// https://discuss.codemirror.net/t/basic-codemirror-configuration-in-typescript-project/2047
// editor showing errors example:
// https://observablehq.com/@ajbouh/editor

CodeMirror.registerHelper('lint', 'formml', function (text) {
  return CodeErrors.map((e) => ({
    from: { line: e.line - 1, ch: e.col - 1 },
    to: { line: e.line - 1, ch: e.col },
    message: e.message,
  }))
})

const inputTypes = Builder.InputTypes.sort()

CodeMirror.hint.formml = function (cm, option) {
  return new Promise(function (accept) {
    setTimeout(function () {
      const cursor = cm.getCursor(),
        line = cm.getLine(cursor.line)
      let start = cursor.ch,
        end = cursor.ch
      while (start && /\w/.test(line.charAt(start - 1))) --start
      while (end < line.length && /\w/.test(line.charAt(end))) ++end
      const word = line.slice(start, end).toLowerCase()
      // console.log('Word: ', word);

      return accept({
        list: inputTypes.filter((ele) => ele.includes(word)),
        from: CodeMirror.Pos(cursor.line, start),
        to: CodeMirror.Pos(cursor.line, end),
      })
    }, 100)
  })
}

let CodeErrors = []

export class FormEditor {
  onCodeChanged = new TypedEvent<boolean>()
  onFormChanged = new TypedEvent<{ code: string; config: any; form: HTMLFormElement }>()
  // onSomeEvent = new TypedEvent<{}>();

  _grammar: any
  _ed: any
  _code = 'name,email,two'
  _prevCode = this._code
  _testMode = true
  config = {}
  lastError = ''
  errorMarks = []

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  constructor(grammar: any, editor: HTMLTextAreaElement, preview: HTMLElement, initialValue, key) {
    this._grammar = grammar
    this._ed = CodeMirror.fromTextArea(editor, {
      mode: 'formml',
      theme: 'monokai',
      gutters: ['CodeMirror-lint-markers'],
      lint: true,
      lineNumbers: true,
      // value: initialValue, // didn't work
      // hintOptions: { hint: filteredHints },
    })

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const oThis = this
    this._ed.on('change', function (cmInstance, changeObj) {
      oThis.code = cmInstance.getValue()
    })

    this._ed.on('keyup', function (cm, event) {
      if (!cm.state.completionActive && event.keyCode == 186) {
        // console.log('Show hint');
        CodeMirror.commands.autocomplete(cm, CodeMirror.hint.formml, { completeSingle: true })
      }
    })

    // Generate the Form
    this.onCodeChanged.on((valid) => {
      if (valid && this._prevCode != this._code) {
        const form: HTMLFormElement = Builder.buildForm(this.config)

        const formPreview = preview.querySelector('form-preview')
        if (!formPreview) {
          // init

          preview.appendChild(new Preview(this._code, key, this._testMode))
        } else {
          // update

          const form = formPreview.shadowRoot.querySelector('formtopia-form')
          form.innerHTML = `<!--\n${this._code}\n-->`
          form.initFromInlineSchema()
        }

        this.onFormChanged.emit({ code: this._code, config: this.config, form })
      } else {
        // this.errorMarks.push(
        //   this._ed.markText({ line: 1, ch: 2 }, { line: 1, ch: 4 }, { className: 'syntax-error', title: 'error' }),
        // );
      }
    })

    if (initialValue) {
      this._ed.setValue(initialValue)
      this.code = initialValue
    }
  }

  get code(): string {
    return this._code
  }

  set code(newCode: string) {
    this._prevCode = this._code
    this._code = newCode
    const result = this._grammar.compile(newCode)

    if (result.status == 200) {
      this.config = result.config
      CodeErrors = []
    } else {
      this.config = {}
      // this.lastError = result.message;
      // console.log(m.message);

      CodeErrors = result.errors
    }

    this.onCodeChanged.emit(result.status == 200)
  }
}
